<template>
  <div>
    <h1 class="page-header">{{ $t('schedule.copy') }}</h1>
    <div class="row">
      <div class="col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loadingPreData">
              <form class="form-horizontal">
                <div class="row mb-3">
                  <div class="col-sm-12 col-lg-6 col-md-12">
                    <!-- Copy From (readonly) -->
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label required"
                      >
                        {{ $t('schedule.copyFrom') }}
                      </label>
                      <div class="col-md-7">
                        <input
                          type="text"
                          class="form-control"
                          :value="model.from_class_name"
                          readonly
                        />
                        <input type="hidden" v-model="model.copy_from_sch_id" />
                      </div>
                    </div>

                    <!-- Copy To -->
                    <div class="form-group row">
                      <label
                        class="col-md-4 form-col-label control-label required"
                      >
                        {{ $t('schedule.copyTo') }}
                      </label>
                      <div class="col-md-7">
                        <treeselect
                          :load-options="loadClass"
                          :options="acClassOptions"
                          :placeholder="$t('typeForSearch')"
                          v-model="model.copy_to_class_id"
                        />
                        <div
                          class="validate"
                          v-if="errors.has('copy_to_class_id')"
                        >
                          {{ errors.first('copy_to_class_id') }}
                        </div>
                      </div>
                    </div>

                    <!-- Buttons -->
                    <div class="form-group row text-right">
                      <label
                        class="col-md-4 form-col-label control-label"
                      ></label>
                      <div class="col-md-7">
                        <ts-button
                          class="btn-primary mr-2"
                          @click.prevent="save"
                          :waiting="saving"
                        >
                          {{ $t('save') }}
                        </ts-button>
                        <ts-button
                          class="btn-default ml-2"
                          @click="$router.push({ name: 'schedule' })"
                        >
                          {{ $t('cancel') }}
                        </ts-button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  name: 'schedule-copy-schedule',
  props: ['schedule'],
  data() {
    return {
      model: {
        from_class_name: null,
        copy_from_sch_id: null,
        copy_to_class_id: null
      },
      errors: new Errors(),
      loadingPreData: false,
      saving: false,
      acClassOptions: null
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    ...mapActions('schedule', ['getClassForCopy']),
    async loadClass({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.acClassOptions = null
        await this.getClassForCopy({
          copy_from_sch_id: this.model.copy_from_sch_id
        })
          .then(response => {
            this.acClassOptions = response.data.map(el => ({
              id: el.class_id,
              label: el.class_name,
              acps_id: el.acps_id
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    setEditData() {
      this.model.from_class_name = this.$route.params.class_name || ''
      this.model.copy_from_sch_id = this.$route.params.sch_id || null
      this.model.copy_to_class_id = null
    },
    async save() {
      this.errors = new Errors()
      this.saving = true

      this.$store
        .dispatch('schedule/copySchedule', {
          copy_from_sch_id: this.model.copy_from_sch_id,
          copy_to_class_id: this.model.copy_to_class_id
        })
        .then(response => {
          this.clearForm()
          this.saving = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'schedule' })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    clearForm() {
      this.model = {
        from_class_name: null,
        copy_from_sch_id: null,
        copy_to_class_id: null
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'schedule') {
      this.$store.commit('schedule/RECEIVE_CLASSES', [])
      this.$store.commit('schedule/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
:deep(.vue-treeselect__menu) {
  max-height: 200px !important;
  overflow-y: auto !important;
}
</style>
